import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { makeStyles } from '@material-ui/core/styles';
import { alpha } from '@material-ui/core';
import NotificationCard from '../../notificationCard';
import { prepareChartOptions, BAR_CHART_COLORS } from './config';

ChartJS.register(CategoryScale, LinearScale, PointElement, Filler, LineElement);

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  root: {
    width: '100%',
    position: 'relative',
    height: 350,
    marginTop: spacing(16),
  },
  rootNoResults: {
    marginTop: spacing(10),
  },
  noResults: {
    boxSizing: 'border-box',
    backgroundColor: primary.white,
    position: 'absolute',
    top: 'calc(50% - 20px)',
    left: 'calc(50% - 16px)',
    width: 'fit-content',
    transform: 'translate(-50%, -50%)',
    padding: spacing(3, 4),
    filter: `drop-shadow(0px 4px 10px ${alpha(primary.black, 0.2)})`,
  },
}));

const ReportChart = ({
  translations,
  chartData = [],
  hasData,
  noDataMessage = '',
}) => {
  const classes = useStyles();

  const labels = Array.from({ length: 10 }, (_, i) => 1 + i);
  const backgroundColor = Array.from({ length: 10 }, (_, i) => 1 + i).map(
    value => BAR_CHART_COLORS[value]
  );
  const options = prepareChartOptions(translations.responses);
  const data = {
    labels,
    datasets: [
      {
        data: chartData,
        backgroundColor,
      },
    ],
  };

  return (
    <div className={classNames(classes.root, { [classes.root]: !hasData })}>
      <Bar options={options} data={data} />
      <NotificationCard
        className={classes.noResults}
        title={noDataMessage}
        shouldFade={!hasData}
        titleVariant="subtitle1"
      />
    </div>
  );
};

ReportChart.propTypes = {
  translations: PropTypes.object.isRequired,
  chartData: PropTypes.arrayOf(PropTypes.object),
  hasData: PropTypes.bool.isRequired,
  noDataMessage: PropTypes.string,
};

export default ReportChart;
